import { render, staticRenderFns } from "./workshop-papers.vue?vue&type=template&id=582d64ee&scoped=true&"
import script from "./workshop-papers.vue?vue&type=script&lang=js&"
export * from "./workshop-papers.vue?vue&type=script&lang=js&"
import style0 from "./workshop-papers.vue?vue&type=style&index=0&id=582d64ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "582d64ee",
  null
  
)

export default component.exports